import { ConflictType, type Finding } from '@consigli/types';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddContextPanel } from './add-context-panel';
import { AddContextRequirementCard } from './add-context-requirement-card';
import { isListedRequirement, requirementSearchText } from './response-requirements';
import { useRfpFindingsList } from './use-rfp-findings-list';

interface AddContextRequirementsPanelProps {
  onSelectedChange: (findings: Finding[]) => void;
  selected: Finding[];
}

/**
 * The response requirements of an RFP package, one card per category, with the
 * search box the design gives this list. Select All then covers what the search
 * left showing.
 */
export const AddContextRequirementsPanel: FC<AddContextRequirementsPanelProps> = ({
  onSelectedChange,
  selected,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const list = useRfpFindingsList(
    ConflictType.DELIVERABLE,
    search,
    requirementSearchText,
    isListedRequirement,
  );
  const searchLabel = t('prop-chat.add-context-search-response-requirements');

  return (
    <AddContextPanel
      emptyMessage={t('prop-chat.add-context-no-response-requirements')}
      list={list}
      onSearchTextChange={setSearch}
      onSelectedChange={onSelectedChange}
      renderItem={(finding, isSelected, onToggle) => (
        <AddContextRequirementCard
          key={finding.id}
          finding={finding}
          onSelectedChange={onToggle}
          selected={isSelected}
        />
      )}
      // 50px past the default, so "Search Response Requirements" fits unclipped.
      searchClassName="w-[290px]"
      searchLabel={searchLabel}
      searchText={search}
      selected={selected}
    />
  );
};
